import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'fc-label',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<ng-content />`,
})
export class LabelComponent {}
